import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ValidationService } from 'app/validation.service';
import { JobService } from 'app/jobService';
import { Router } from '@angular/router';
import { Educational } from 'app/educational';

@Component({
  selector: 'apply-job-section3',
  templateUrl: './apply-job-section3.component.html',
  styleUrls: ['./apply-job-section3.component.scss']
})
export class ApplyJobSection3Component implements OnInit {
  modelForm: FormGroup;
  x: any;
  bypass: boolean;
  constructor(private formBuilder: FormBuilder, private js: JobService, private router: Router) {

  }

  ngOnInit() {
    this.bypass = false;
    this.js.navigate = 3;
    this.modelForm = this.formBuilder.group({
      positions: this.formBuilder.array([])
    });

    if (this.js.listEducation.length === 0) {
      //this.addPosition();
    } else {
      this.js.listEducation.forEach(element => {
        this.renderPosition(element);
      });

      this.x = this.js.listEducation;
    }
  }

  get positions(): FormArray {
    return <FormArray>this.modelForm.get('positions');
  }

  addPosition(): void {
    this.positions.push(this.buildPosition());
  }

  buildPosition(): FormGroup {
    return this.formBuilder.group({
      EducationalID: '0',

      EducationalLevel: '',
      InstitutionName: '',

      EducationalName: '',
      Faculty: '',

      Branch: '',
      GPA: '',

      ApplyJobID: "" + this.js.applyJobID + "",
    });
  }

  renderPosition(edu: Educational): void {
    this.positions.push(this.buildPosition2(edu))
  }

  buildPosition2(educational: Educational): FormGroup {
    return this.formBuilder.group({
      EducationalID: "" + educational.EducationalID + "",

      EducationalLevel: "" + educational.EducationalLevel + "",
      InstitutionName: "" + educational.InstitutionName + "",

      EducationalName: "" + educational.EducationalName + "",
      Faculty: "" + educational.Faculty + "",

      Branch: "" + educational.Branch + "",
      GPA: "" + educational.GPA + "",

      ApplyJobID: "" + educational.ApplyJobID + "",
    });
  }

  removePosition(i): void {
    this.positions.removeAt(i);
  }

  onSubmit(form) {
    console.log(form);
  }

  AddEducational() {
    if (this.bypass) {
      this.GoToapplyjobsection4();
    } else {
      this.x = this.modelForm.get('positions').value;
      this.js.listEducation = this.x;

      if (this.js.listEducation.length > 0) {
        this.js.NewEducationalAPI().subscribe(
          (applyJobID) => {
            if (Number(applyJobID) !== 0) {
              this.js.applyJobID = Number(applyJobID);
              this.GoToapplyjobsection4();
            } else {
              alert("กรุณากรอกข้อมูลวุฒิการศึกษาให้ครบถ้วน");
            }
          },
          (error) => { alert(JSON.stringify(error)) },
          () => {
          }
        );
      } else {
        alert("กรุณากดปุ่มเพิ่มวุฒิการศึกษาหรือติ๊กเลือกไม่มีวุฒิการศึกษา")
      }

    }
  }

  GoToapplyjobsection4() {
    this.router.navigateByUrl('applyjobsection4');
  }

  CheckValidate(): boolean {
    if (this.bypass) {
      return true;
    } else {
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/apply-job-section3/apply-job-section3.component.ts